<div class="header">
    <h1>{{title}}</h1>
    <div class="spacer"></div>
    <ng-container *ngIf="isEditable">
        <btn *ngIf="!isEdit"
             type="actionMore"
             icon="fa-pen"
             (onClick)="edit()"></btn>
        <btn *ngIf="isEdit"
             type="actionPrincipal"
             icon="fa-check"
             (onClick)="edit()"></btn>
    </ng-container>
</div>
<div class="description" *ngIf="description">
    <label [innerHTML]="description"></label>
</div>
<notification type="error"
              *ngIf="errorNotification.active">
    {{errorNotification.message}}
</notification>
<div class="content contentCustomer">
    <div *ngIf="!isEdit; else editCustomer">
        <div class="row">
            <label class="icon"><fa-icon [icon]="iconAddressBook"></fa-icon></label>
            <label>{{formValue | travellerIdentity}}</label>
        </div>
        <div class="row">
            <label class="icon"><fa-icon [icon]="iconMail"></fa-icon></label>
            <label *ngIf="formValue.mail; else notDefNes"> {{formValue.mail}} </label>
        </div>
        <div class="row">
            <label class="icon"><fa-icon [icon]="iconPhone"></fa-icon></label>
            <label *ngIf="formValue.phone; else notDef"> {{formValue.phone}} </label>
        </div>
        <div class="row">
            <label class="icon"><fa-icon [icon]="iconAddress"></fa-icon></label>
            <label *ngIf="address; else notDef"> {{address}} </label>
        </div>
    </div>
</div>

<ng-template #editCustomer>
    <div>
        <div class="rowLarge">
            <simple-select class="Littleinput"
                           [fieldConfig]="config.titleConfig"
                           [withBorder]="withBorder"
                           (blur)="editCustomerEvent()">
            </simple-select>
            <text class="input"
                  [fieldConfig]="config.lastNameConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editCustomerEvent()"
                  (onKeyPress)="editCustomerEvent()">
            </text>
            <text class="input"
                  [fieldConfig]="config.firstNameConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editCustomerEvent()"
                  (onKeyPress)="editCustomerEvent()">
            </text>
        </div>
        <div class="rowLarge">
            <label class="icon"><fa-icon [icon]="iconMail"></fa-icon></label>
            <text class="input"
                  [fieldConfig]="config.mailConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editCustomerEvent()"
                  (onKeyPress)="editCustomerEvent()">
            </text>
        </div>
        <div class="rowLarge">
            <label class="icon"><fa-icon [icon]="iconPhone"></fa-icon></label>
            <text class="input"
                  [fieldConfig]="config.phoneConfig"
                  [isInternalError]="isInternalError"
                  (onBlur)="editCustomerEvent()"
                  (onKeyPress)="editCustomerEvent()">
            </text>
        </div>
        <div class="rowLarge">
            <label class="icon"><fa-icon [icon]="iconAddress"></fa-icon></label>
            <div class="contentAddress">
                <div class="rowAddress">
                    <div class="rowAddress" *ngFor="let configAddress of config.address.nameStreetConfig; let i = index">
                        <text class="inputAdd"
                              [fieldConfig]="configAddress"
                              [isInternalError]="isInternalError"
                              (onBlur)="editCustomerEvent()"
                              (onKeyPress)="editCustomerEvent()">
                        </text>
                        <btn *ngIf="i + 1 === config.address.nameStreetConfig.length && config.address.nameStreetConfig.length < 2"
                             type="actionPrincipal"
                             icon="fa-plus"
                             (onClick)="addAddLine(i + 1)"
                        ></btn>
                    </div>
                </div>
                <div class="rowAddress">
                    <text class="inputSmall"
                          [fieldConfig]="config.address.zipCodeConfig"
                          [isInternalError]="isInternalError"
                          (onBlur)="editCustomerEvent()"
                          (onKeyPress)="editCustomerEvent()">
                    </text>
                    <text class="input"
                          [fieldConfig]="config.address.cityConfig"
                          [isInternalError]="isInternalError"
                          (onBlur)="editCustomerEvent()"
                          (onKeyPress)="editCustomerEvent()">
                    </text>
                    <text class="input"
                          [fieldConfig]="config.address.countryConfig"
                          [isInternalError]="isInternalError"
                          (onBlur)="editCustomerEvent()"
                          (onKeyPress)="editCustomerEvent()">
                    </text>

                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #notDef>
    <label class="notDef">{{wording.undefined}}</label>
</ng-template>

<ng-template #notDefNes>
    <label class="notDefNes">{{wording.undefined}}</label>
</ng-template>
